import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import PageTitle from 'components/_base/PageTitle';

import ContentAdminUsuarios from './ContentAdminUsuarios';

const App = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <PageTitle title="Usuarios" />
      <hr />
      <ContentAdminUsuarios />
      <Bottom />
    </div>
  );
};

export default App;
